export default "https://assets.egbcdn.net/assets/packs/_/sounds/incubator_bet-fe643786d414eaa6212cbb72d5749993.mp3";